/**
 * Shell-level rail events. A section whose registry entry sets
 * `editorOnDemand: true` starts with NO editor column — the content spans the
 * freed width — until its editor announces it has something to show. The
 * editor component stays mounted the whole time (it owns the subscriptions
 * that open it); only the column is hidden.
 */
export const RAIL_OPEN = "section-rail:open";
export const RAIL_CLOSE = "section-rail:close";

/**
 * Cross-section navigation. A section that links to a sibling (the medicines
 * drug-allergies bar → Allergies) emits this with the target section key;
 * PatientDetails owns the active-section state and listens.
 */
export const SECTION_SELECT = "section-rail:select";
